import { CrmComment } from "./comments"

export enum TaskType {
  TODO = "TODO",
  CALL = "CALL",
  EMAIL = "EMAIL",
}

export enum TaskPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum TaskStatus {
  COMPLETED = "COMPLETED",
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  WAITING = "WAITING",
}
/** Server-side presets on the task list endpoints (`?quickFilter=`). */
export type TaskQuickFilter = "OVERDUE";

export interface TaskFormValues {
  title: string
  description: string
  taskType: string
  priority: string
  taskOwnerUuid: string | null
  taskStatus?: string
  dueAt: string
  relatedTo?: string
}

export interface TaskUser {
  uuid: string
  name: string
  email: string
  profileImageUrl?: string
}



export interface CrmTask {
  uuid: string
  title: string
  description: string
  dueAt: string
  taskStatus: TaskStatus
  appUser: TaskUser
  createdBy: TaskUser
  taskOwner: TaskUser
  taskType: string
  priority: string
  timezone: string
  createdDate: string
  completedAt: string | null
  comments?: CrmComment[]
  commentCount: number
}
export type CreateTaskTargetType = "DEAL" | "COMPANY" | "CONTACT"
interface CreateCrmTaskBasePayload {
  targetType: CreateTaskTargetType
  targetReference: string
  title: string
  description?: string
  dueAt: string
  taskType: string
  priority: string
  taskStatus: string
  assigneeUserUuid?: string
  timezone?: string
}

export type CreateCrmTaskPayload =
  | (CreateCrmTaskBasePayload & { contactUuid: string; companyUuid?: never; dealUuid?: never })
  | (CreateCrmTaskBasePayload & { companyUuid: string; contactUuid?: never; dealUuid?: never })
  | (CreateCrmTaskBasePayload & { dealUuid: string; contactUuid?: never; companyUuid?: never })

export type CreateCrmContactTaskPayload = CreateCrmTaskBasePayload & { contactUuid: string }
export type CreateCrmCompanyTaskPayload = CreateCrmTaskBasePayload & { companyUuid: string }
export type CreateCrmDealTaskPayload = CreateCrmTaskBasePayload & { dealUuid: string }

export interface PaginatedTasks {
  content: CrmTask[]
  page: number
  size: number
  totalElements: number
  totalPages: number
  last: boolean
}

export interface TaskResponse {
  success: boolean
  status: string
  statusCode: number
  message: string
  data: CrmTask
}

export interface TasksListResponse {
  success: boolean
  status: string
  statusCode: number
  message: string
  data: PaginatedTasks
}

// Generic task list item returned by GET /crm/tasks
// (different shape from CrmTask: has target* + assignee instead of owner/appUser)
export interface CrmTaskListItem {
  uuid: string
  targetType: "DEAL" | "COMPANY" | "CONTACT"
  targetUuid: string
  targetKey: string
  targetName: string
  title: string
  description?: string
  dueAt?: string
  taskType: string
  taskTypeLabel: string
  priority: string
  priorityLabel: string
  taskStatus: TaskStatus
  taskOwner: TaskUser
  createdBy: TaskUser
  createdDate: string
  createdAt: string
  lastModifiedAt: string
  completedAt?: string | null
  commentCount: number
}

export interface GetTasksParams {
  search?: string
  status?: TaskStatus
  page?: number
  size?: number
}

export interface CreateTaskPayload {
  targetType: "DEAL" | "COMPANY" | "CONTACT"
  targetReference: string
  title: string
  description?: string
  dueAt?: string
  taskStatus?: string
  taskType: string
  priority: string
  taskOwnerUuid?: string
  timezone?: string
}

export interface PaginatedTaskListItems {
  content: CrmTaskListItem[]
  page: number
  size: number
  totalElements: number
  totalPages: number
  last: boolean
}

export interface TaskListResponse {
  success: boolean
  status: string
  statusCode: number
  message: string
  data: PaginatedTaskListItems
}

export const taskTypeOptions = [
  { value: TaskType.TODO, label: "To-do" },
  { value: TaskType.CALL, label: "Call" },
  { value: TaskType.EMAIL, label: "Email" },
];

export const priorityOptions = [
  { value: TaskPriority.LOW, label: "Low" },
  { value: TaskPriority.MEDIUM, label: "Medium" },
  { value: TaskPriority.HIGH, label: "High" },
];

export const taskStatusOptions = [
  { value: TaskStatus.NOT_STARTED, label: "Not Started" },
  { value: TaskStatus.IN_PROGRESS, label: "In Progress" },
  { value: TaskStatus.WAITING, label: "Waiting" },
  { value: TaskStatus.COMPLETED, label: "Completed" },
]